<template>
    <div>
        <modal
            class="new-modal-small"
            :name="modal_name"
            transition="nice-modal-fade"
            :delay="100"
            height="auto"
            :min-height="200"
            :min-width="500"
            :pivot-y="0.5"
            :adaptive="true"
            :scrollable="false"
            style="pointer-events:inherit !important" 
            v-bind:click-to-close="false"
        >
            <div class="v-modal-content d-flex flex-column" style="background-color: #fff !important; height: 100% !important;">
                <div class="upload-bulk pl-5 pr-5" style="height: 250px !important;overflow-x: hidden !important;overflow-y: scroll !important;">
                    <div class="header-text pt-5 pb-4" style="text-align: left !important;"> 
                        <span style="color: #E82828 !important;">Error</span>
                    </div>
                    <div>
                        <!-- <span class="fs-14 fw-400">{{error}}</span><br> -->
                        <ol style="margin-left: -27px !important;font-family: 'Poppins', sans-serif !important;">
                            <li class="fs-14 fw-400" v-for="(error,err_index) in data" :key="err_index">{{ error}}.</li>
                        </ol>
                    </div>
                </div>
                <div class="d-flex aligin-items-center justify-content-center mt-6 mb-6">
                    <button class="btn new-no-button mr-4 px-4" @click="closeModal">Remove</button>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
import { HollowDotsSpinner } from "epic-spinners";
import { EventBus } from '../eventBus/nav-bar-event';
export default {
    props: ["modal_name", "warning_msg"],
    data() {
        return{
            data: []
        }
    },
    components: {
        HollowDotsSpinner
    },
    methods: {
        closeModal() {
            this.$emit("hideErrorFile");
        },
    },
    mounted(){
        this.data = this.warning_msg
    }
}
</script>
<style>
    .attachment-bg {
        background-color: #fff !important;
        border: 1.5px dashed #89898d;
        padding: 15px;
        border-radius: 10px;
        width: 100%;
    }
    .upload-bulk{
        margin: 10px !important;
        width: 100%;
    }
    .click-here{
        color: #206ad3;
        text-decoration: underline;
        font-size: 12px;
    }
    .text-color{
        color: #c6c7c9;
        font-size: 16px;
    }
    .header-text{
        color: #00448b;
        font-size: 18px;
        font-weight: 600;
    }
    .new-modal-small.v--modal-overlay .v--modal-box{
        max-width: 500px !important;
        width: 500px !important;
    }
    .new-modal-small.v--modal-overlay .v--modal-box.v--modal {
        height: 300px !important;
        /* overflow-y: scroll !important;
        overflow-x: hidden !important; */
        left: 28% !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/Leads/FileError.vue